export const ReviewTemplateAccessType = {
    COMPANY_WIDE: 'CompanyWide',
    APP_WIDE: 'AppWide',
} as const;

export type ReviewTemplateAccessType =
    (typeof ReviewTemplateAccessType)[keyof typeof ReviewTemplateAccessType];
